module.exports = __webpack_public_path__ + "public/img/junyao_logo.d8051186.jpg";